import { useContext, useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import { BaseUrl, GetPhonePayPaymentLink } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { ServiceDiscounts } from "../../Components/enum";
import Batuk from '../../assets/images/new/fav-removebg-preview.png'
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import { LoaderContext } from "../../AuthContext/AuthContext";
import DeliveryTracker from "../../Components/DeliveryTracker/DeliveryTracker";
import LazySection from "../Home/LazySection";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
import { t } from "i18next";
const DBOrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const { setLoader } = useContext(LoaderContext);
  const location = useLocation();
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const navigate = useNavigate();
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)

  const order = location.state.order;
  const SGST = 9;
  const CGST = 9;
  // const needSamagri = "{t("Yes")}";
  const needSamagri = order?.NEED_SAMAGRI;

  // const Tax = Math.round(
  //   (ServiceDiscounts.DailyBookingDiscount / 100) * parseFloat(totalAmount)
  // );
  useEffect(() => {
    if (order?.DPB_ID !== null && order?.DPB_ID !== undefined && order?.DPB_ID !== '') {
      GetOrderTrackingDetailsData()
    }
  }, [order])
  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, order?.DPB_ID, 'DailyPuja'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const numberOfDays = (startDate, endDate) => {
    const totalDays =
      (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);

    return totalDays + 1;
  };

  const totalAmount = (
    price,
    fromDate,
    toDate,
    samagriPrice,
    needSamagri,
    convenienceFee,
    discount
  ) => {
    //  ;
    const res =
      Number(price) * numberOfDays(fromDate, toDate) +
      (needSamagri === "yes"
        ? Number(samagriPrice || 0) * numberOfDays(fromDate, toDate)
        : 0) +
      Number(convenienceFee) -
      discount;

    return res;
  };

  const tax = Math.round(
    (ServiceDiscounts.DailyBookingDiscount / 100) *
    Number(order?.CONVENIENCE_FEE)
  );

  // const grandTotal = parseFloat(totalAmount || 0) + tax;

  const CalculateGrandTotal = (
    price,
    fromDate,
    toDate,
    samagriPrice,
    needSamagri,
    convenienceFee,
    discount
  ) => {
    //  ;
    return (
      totalAmount(
        price,
        fromDate,
        toDate,
        samagriPrice,
        needSamagri,
        convenienceFee,
        discount
      ) +
      Math.round(
        (ServiceDiscounts.panditBookingDiscount / 100) *
        Number(
          totalAmount(
            price,
            fromDate,
            toDate,
            samagriPrice,
            needSamagri,
            convenienceFee,
            discount
          )
        )
      )
    );
  };


  // const Remaining_Amount =
  //   Number(order?.DPB_PRICE) +
  //   Number(needSamagri === "yes" ? order?.DPB_SAMAGRIPRICE : 0) +
  //   Number(order?.CONVENIENCE_FEE) +
  //   Tax - //Added Tax
  //   order?.TRANSACTION_AMT;

  const Remaining_Amount = Math?.round(order?.RemainingAmount)


  const handleProceedRemainingDailyPujaPayment = async () => {

    if (Remaining_Amount === 0) {
      alert("All the amount already paid");
      return;
    }

    let orderIDReturned = order?.DPB_ID;

    const PlaceOrderResponse = await handleProceedRemainingPayment(order.RemainingAmount)

    setLoader(true)
    if (PlaceOrderResponse?.status === 1) {
      axios
        .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=DailyPuja`, {
          USER_ID: userID,
          ORDER_ID: orderIDReturned,

          TRANSACTION_ID: PlaceOrderResponse?.razorpay_payment_id,
          PAYMENT_STATUS: "Success",
          TRANSACTION_STATUS: "Success",
          TRANSACTION_AMT: order?.RemainingAmount,
          REMAING_AMOUNT: 0,
          PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
        })
        .then((res) => {
          if (res.data.ResponseMessage === "Success.") {
            setLoader(false)
            navigate("/my-order-daily-Booking");
          } else {
            setLoader(false)
            alert("Order placement failed, please try again.");
          }
        });

    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }



    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: Remaining_Amount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {

        const paymentId = response.razorpay_payment_id;

        if (response) {
          axios
            .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=DailyPuja`, {
              USER_ID: userID,
              ORDER_ID: orderIDReturned,
              // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
              TRANSACTION_ID: paymentId,
              PAYMENT_STATUS: "Success",
              TRANSACTION_STATUS: "Success",
              TRANSACTION_AMT: order?.RemainingAmount,
              // TRANSACTION_AMT: CalculateGrandTotal(
              //   order.DPB_PRICE,
              //   order.DPB_FROMDATE,
              //   order.DPB_TODATE,
              //   order.DPB_SAMAGRIPRICE,
              //   order.NEED_SAMAGRI,
              //   order.CONVENIENCE_FEE,
              //   order.DiscountAmount
              // ),
              REMAING_AMOUNT: 0,
              PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
            })
            .then((res) => {
              if (res.data.ResponseMessage === "successfully.") {
                // localStorage.setItem("cartItemCount", "0");
                // window.dispatchEvent(new Event("cartUpdated"));
                // setShowCODModal(false);
                // nextStep();
                navigate("/my-order-daily-Booking");
              } else {
                alert("Order placement failed, please try again.");
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {
        //    ;
        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };



  const handlePhonePayProceedRemainingPayment = async () => {
    //  ;
    if (Remaining_Amount === 0) {
      alert("All the amount already paid");
      return;
    }

    let orderIDReturned = order.DPB_ID;
    const PhonePayOption = {
      UserID: userID,
      MobileNumber: 7218511742,
      ModalName: 'dailyPujaBookingRemaining',
      Amount: order.RemainingAmount,
    };



    const Payload = {
      USER_ID: userID,
      ORDER_ID: orderIDReturned,
      // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
      // TRANSACTION_ID: paymentId,
      PAYMENT_STATUS: "Success",
      TRANSACTION_STATUS: "Success",
      TRANSACTION_AMT: order?.RemainingAmount,

      REMAING_AMOUNT: 0,
      PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
    }
    axios
      .post(`${BaseUrl}/${GetPhonePayPaymentLink}`, PhonePayOption)
      .then((res) => {
        if (res?.data?.success) {


          // Use navigate with state instead of window.location.href
          localStorage.setItem('dailyPujaBookingData', JSON.stringify(Payload));

          window.location.href = res.data.redirectUrl;
        } else {
          console.error("PhonePe Payment Failed:", res.data);
          alert("Something went wrong while creating the payment link.");
        }
      })
      .catch((error) => {
        console.error("PhonePe API Error:", error);
        alert("Failed to initiate PhonePe payment. Please try again.");
      });
  };

  const fhandlePhonePayProceedRemainingPayment = async () => {

    if (Remaining_Amount === 0) {
      alert("All the amount already paid");
      return;
    }
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    // let minPayableAmount = Remaining_Amount; // 20% of the total amount

    let orderIDReturned = order?.DPB_ID;
    const PhonePayOption = {
      UserID: userID,
      MobileNumber: 7218511742,
      ModalName: 'dailyPoojaBookingRemaining',
      Amount: order.RemainingAmount,
    };


    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: Remaining_Amount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {

        const paymentId = response.razorpay_payment_id;

        if (response) {
          axios
            .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=DailyPuja`, {
              USER_ID: userID,
              ORDER_ID: orderIDReturned,
              // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
              TRANSACTION_ID: paymentId,
              PAYMENT_STATUS: "Success",
              TRANSACTION_STATUS: "Success",
              TRANSACTION_AMT: order?.RemainingAmount,

              REMAING_AMOUNT: 0,
              PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
            })
            .then((res) => {
              if (res.data.ResponseMessage === "successfully.") {
                // localStorage.setItem("cartItemCount", "0");
                // window.dispatchEvent(new Event("cartUpdated"));
                // setShowCODModal(false);
                // nextStep();
                navigate("/my-order-daily-Booking");
              } else {
                alert("Order placement failed, please try again.");
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {
        //    ;
        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };



  const paymentBtnClick = () => { };

  const createMarkup = (html) => {
    return { __html: html };
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    return new Date(0, 0, 0, hours, minutes).toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleDownloadInvoice = (PB_ID) => {
    window.open(order?.InvoicePDFURL, "_blank");

  };

  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];
  return (
    <>
      <div>
        <div className="top">
          <div
            className="pujaDetails custom-flex"
            style={{
              display: "flex",
              padding: "20px",
              alignItems: "flex-start",
              maxHeight: "80vh", // restrict overall height
              overflow: "hidden", // prevent container from overflowing
            }}
          >
            <div
              className="left"
              style={{
                position: "sticky",
                top: "20px",
                flexShrink: 0,
              }}
            >
              <img src={order?.DP_IMAGE || Batuk} alt="Puja-Img" />
            </div>
            <div
              className="right"
              style={{
                marginLeft: "20px",
                overflowY: "auto",
                maxHeight: "80vh", // match the parent height
                paddingRight: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center", // Ensures vertical alignment
                  marginBottom: "10px",
                }}
              >
                {/* <h6
                  className="list-group-item custom-list-item clearfix"
                  style={{
                    fontFamily: "Bricolage Grotesque",
                    fontSize: "20px",
                    textTransform: "none",
                    margin: 0, // Remove default margin for better alignment
                  }}
                >
                  Puja Details
                </h6> */}
                <h2
                  style={{
                    fontFamily: "Bricolage Grotesque",
                    fontSize: "20px",
                    textTransform: "none",
                    margin: 0, // Remove default margin for better alignment
                  }}
                >
                  {order?.DP_NAME}
                </h2>
                {Remaining_Amount > 0 && (
                  <div className="button-container">
                    <button
                      className="Normal-app-btn"
                      onClick={() => handleProceedRemainingDailyPujaPayment()}
                    >
                      {t("Proceed To Payment")}
                    </button>
                    {/* <button
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#A52444",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={handlePhonePayProceedRemainingPayment}
                    >
                      Proceed To Phone Pay Payment
                    </button> */}
                  </div>
                )}
              </div>

              {/* <h4>
                {" "}
                <span>
                  {" "}
                  {formatToIndianCurrency(
                    order?.DPB_PRICE - order?.DiscountAmount
                  )}
                </span>
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "#777",
                    marginLeft: "10px",
                  }}
                >
                  {order?.DPB_PRICE}
                </span>
                <span
                  style={{
                    color: "black",
                    marginLeft: "10px",
                    fontSize: "18px",
                  }}
                >
                  ({Math.round((order?.DiscountAmount / order?.DPB_PRICE) * 100)}%
                  OFF)
                </span>
              </h4> */}
              {/* <h5>
                <span>
                  <s>Rs {order?.PB_PRICE}</s>
                </span>
              </h5> */}

              <div className="mb-3 ">
                {/* <h5>Puja Details:</h5> */}
                <p
                  dangerouslySetInnerHTML={{
                    __html: order?.DP_DESC,
                  }}
                />
              </div>
              {order?.NEED_SAMAGRI === 'yes' && (
                <>
                  <div className="mb-3">
                    <h5>{t("Samagri")}:</h5>
                    {order?.DP_SAMAGRI ? (
                      <div
                        dangerouslySetInnerHTML={createMarkup(order?.DP_SAMAGRI)}
                      />
                    ) : (
                      <p>{t("No samagri details available.")}</p>
                    )}
                  </div>

                  {/* <h5>
                    Samagri Price: Rs{" "}
                    {formatToIndianCurrency(order?.DPB_SAMAGRIPRICE)}
                  </h5> */}
                </>
              )}


              {/* <div className="button-container">
              <button
                className="btn btn-primary"
                style={{ backgroundColor: "#A52444", color: "white" }}
                onClick={handleOpenProductBookingModal}
              >
                Proceed to Book
              </button>
            </div> */}
            </div>
          </div>
        </div>
        {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

          <div >
            <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
          </div>
        )}
        <div className="container my-4">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold">
                    {t("Puja Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Name")}</td>
                        <td style={{ fontWeight: "bold" }}>
                          {order?.DP_NAME}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Booking Date")}</td>
                        <td>{order?.REG_DATE}</td>
                      </tr>
                      <tr>
                        <td>{t("Language")}</td>
                        <td>{order?.LANG_NAME}</td>
                      </tr>
                      <tr>
                        <td>{t("Puja Date")}</td>
                        <td>
                          {order?.DPB_FROMDATE} {t("To")} {order?.DPB_TODATE}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Puja Time")}</td>
                        <td>
                          {`${(order?.DPB_FROMTIME)} ${t("To")} ${(
                            order?.DPB_TOTIME
                          )}`}
                        </td>
                      </tr>

                      {order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "yes" ?
                        <tr>
                          <td>{t("Samagri")}</td>
                          <td>{t("Yes")}</td>
                        </tr>
                        : order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "no" ?
                          <tr>
                            <td>{t("Dry Samagri")}</td>
                            <td>{t("Yes")}</td>
                          </tr> : order.NeedDrySamagri === "no" && order.NeedWetSamagri === "yes" ?
                            <tr>
                              <td>{t("Wet Samagri")}</td>
                              <td>{t("Yes")}</td>
                            </tr> : <tr>
                              <td>{t("Samagri")}</td>
                              <td>{t("No")}</td>
                            </tr>
                      }


                      <tr>
                        <td>{t("Payment Mode")}</td>
                        <td>{order?.PAYMENT_TYPE}</td>
                      </tr>
                      <tr>
                        <td>{t("Payment Status")}</td>
                        <td className="fw-bold">{order?.PAYMENT_STATUS === 'Complete' ? t('Completed') : t(order?.PAYMENT_STATUS)}</td>
                      </tr>
                      <tr>
                        <td>{t("Transaction Amount")}</td>
                        <td>{formatToIndianCurrency(Math.round(order?.TRANSACTION_AMT))}</td>
                      </tr>
                      <tr>
                        <td>{t("Remaining Amount")}</td>
                        <td>
                          {formatToIndianCurrency(Math.round(order?.RemainingAmount)) || 0}
                          {/* {formatToIndianCurrency(
                            CalculateGrandTotal(
                              order.DPB_PRICE,
                              order.DPB_FROMDATE,
                              order.DPB_TODATE,
                              order.DPB_SAMAGRIPRICE,
                              order.NEED_SAMAGRI,
                              order.CONVENIENCE_FEE,
                              order.DiscountAmount
                            ) - order.TRANSACTION_AMT
                          ) || 0} */}
                          {/* {formatToIndianCurrency(
                          Number(order.DPB_PRICE) +
                            Number(
                              needSamagri === "yes" ? order.DPB_SAMAGRIPRICE : 0
                            ) +
                            Number(order.CONVENIENCE_FEE) +
                            Tax - //Added Tax
                            order.TRANSACTION_AMT
                        ) || 0} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold">
                    {t("Pandit Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Pandit Name")}</td>
                        <td style={{ fontWeight: "bold" }}>
                          {order.PANDIT_NAME === null || order.PANDIT_NAME === undefined ? 'Pending' : order.PANDIT_NAME}

                        </td>
                      </tr>
                      <tr>
                        <td>{t("Pandit Contact")}</td>
                        <td>
                          {order.PANDIT_NAME === null || order.PANDIT_NAME === undefined ? 'Pending' : order.MOBILE_NO}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Pandit Status")}</td>
                        <td className="fw-bold">{order?.PANDIT_STATUS === 'Complete' ? 'Completed' : order?.PANDIT_STATUS}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold">
                    {t("Price Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Price")} (₹)</td>
                        <td>
                          {formatToIndianCurrency(Math.round(Number(order.DPB_PRICE) - (Number(order.DPB_PRICE) * Number(order.DP_DISC) / 100)))}
                          {/* {formatToIndianCurrency(
                            order?.DPB_PRICE *
                              numberOfDays(order?.DPB_FROMDATE, order?.DPB_TODATE)
                          )} */}
                        </td>
                      </tr>
                      {/* {Number(order?.DP_DISC) !== 0 && (
                        <tr>
                          <td>Discount ({order?.DP_DISC}%)</td>
                          <td>
                            - {formatToIndianCurrency(order?.DiscountAmount)}
                          </td>
                        </tr>
                      )} */}
                      {order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "yes" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td> {t("Samagri Price")} (₹)</td>
                          <td >
                            {formatToIndianCurrency(
                              Math.round(
                                (Number(order.WetSamagriPrice) +
                                  Number(order.WetSamagriPriceTaxAmount === null ? 0 : order.WetSamagriPriceTaxAmount)) + (Number(order.DrySamagriprice) +
                                    Number(order.DrySamagriPriceTaxAmount === null ? 0 : order.DrySamagriPriceTaxAmount))
                              )
                            )}
                          </td>
                        </tr>
                      ) : order.NeedDrySamagri === "yes" && order.NeedWetSamagri === "no" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td>{t("Dry Samagri Price")} (₹)</td>
                          <td >
                            {formatToIndianCurrency(
                              Math.round(
                                (Number(order.DrySamagriPrice) +
                                  Number(order.DrySamagriPriceTaxAmount === null ? 0 : order.DrySamagriPriceTaxAmount))
                              )
                            )}
                          </td>
                        </tr>
                      ) : order.NeedDrySamagri === "no" && order.NeedWetSamagri === "yes" && order.NeedWetSamagri !== null && order.NeedDrySamagri !== null ? (
                        <tr>
                          <td>{t("Wet Samagri Price")} (₹)</td>
                          <td >
                            {formatToIndianCurrency(
                              Math.round(
                                Number(order.WetSamagriPrice) +
                                Number(order.WetSamagriPriceTaxAmount === null ? 0 : order.WetSamagriPriceTaxAmount)
                              )
                            )}
                          </td>
                        </tr>
                      ) : ''}
                      {/* <tr>
                        <td>Samagri Tax ({order?.SamagriPriceTaxPercent}%)</td>
                        <td>
                          {formatToIndianCurrency(
                            order?.SamagriPriceTaxAmount
                          )}
                        </td>
                      </tr> */}
                      {Number(order?.CONVENIENCE_FEE) !== 0 && (
                        <tr>
                          <td>{t("Convenience Fee")} (₹)</td>
                          <td>
                            {formatToIndianCurrency(order?.CONVENIENCE_FEE + Math.round(Number(order?.ConvinienceFeeTaxAmount)))}
                          </td>
                        </tr>
                      )}

                      {order.CouponCodeAmount !== 0 ? (
                        <tr>
                          <td>
                            {t("Coupon Amount")} (₹)
                          </td>
                          <td className="text-start">
                            {order.CouponCodeAmount}
                          </td>
                        </tr>
                      ) : order.WalletAmount !== 0 ?
                        <tr>
                          <td>
                            {t("Wallet Amount")} (₹)
                          </td>
                          <td className="text-start">
                            {order.WalletAmount}
                          </td>
                        </tr> : ''}


                      <tr>
                        <td className="fw-bold">{t("Grand Total")} (₹)</td>
                        <td className="fw-bold">

                          {formatToIndianCurrency(
                            Math.round(order?.DPB_GrandTotal)
                            // CalculateGrandTotal(
                            //   order?.DPB_PRICE,
                            //   order?.DPB_FROMDATE,
                            //   order?.DPB_TODATE,
                            //   order?.DPB_SAMAGRIPRICE,
                            //   order?.NEED_SAMAGRI,
                            //   order?.CONVENIENCE_FEE,
                            //   order?.DiscountAmount
                            // )
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {order.PAYMENT_STATUS === "Complete" && (
                <a
                  target="_blank"
                  className="careox-btn mt-2"
                  onClick={() => handleDownloadInvoice(order.PB_ID)}
                >
                  {t("Download Invoice")}
                </a>
              )}
              {/* <button
                className="careox-btn mt-2 mx-2"
                onClick={() => {

                  if (order?.PAYMENT_TYPE == 'COD') {
                    navigate("/receipt-details", {
                      state: { moduleName: "DailyPujaBooking", orderID: order?.DPB_ID },
                    })
                  } else {

                    navigate("/view-receipt", {
                      state: { moduleName: "DailyPujaBooking", orderID: order?.DPB_ID },
                    })
                  }
                }
                }

              >
                View Receipt
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DBOrderDetails;
